import { Component, Input } from '@angular/core';
import { OrganizationService } from '@app/service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent {   
  @Input() loading = false;

  constructor(public organizationService: OrganizationService) {
  }

}